import { Directive, TemplateRef } from '@angular/core';

/**
 * Content for a `n-step` that will be rendered lazily.
 */
@Directive({
  selector: 'ng-template[nStepContent]',
})
export class NStepContentDirective {
  constructor(readonly template: TemplateRef<any>) {}
}
